import React, { PureComponent } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
  AreaChart,
  Area,
  ResponsiveContainer,
} from 'recharts';

const data = [
  {
    name: 'Page A',
    pulse: 10,
  },
  {
    name: 'Days',
    pulse: 25,
  },
  {
    name: 'Weeks',
    pulse: 120,
  },
  {
    name: 'Months',
    pulse: 40,
  },
  {
    name: 'Years',
    pulse: 100,
  }
];

export default function Linechart() {
  return (
    <div>
        <ResponsiveContainer className="linechart_outer" width="100%" height={400}>
          <LineChart
            width={500}
            height={100}
            data={data}
          >
            <Legend layout="horizontal" verticalAlign="top" align="right" />
            <CartesianGrid strokeDasharray="1 1" vertical={false} opacity={0.4}/>
            <XAxis dataKey="name" axisLine={false} tickLine={false}/>
            <YAxis axisLine={false} tickLine={false}/>
            
            <Line 
                className="linechart_inner" 
                type="monotone"
                dataKey="pulse"
                stroke="#005CFF" 
                fill="#005CFF"
                strokeWidth={4}
            />
          </LineChart>
        </ResponsiveContainer>
    </div>
  )
}
